import { Component, ViewEncapsulation, ViewChild, OnInit, ElementRef } from '@angular/core';
import { KYMW00Model } from '../../../commons/kymw00/kymw00.model';
import { KYMW5800Model } from './kymw5800.model';
import { PlessViewHelperSub } from '../../../commons/kymw00/pless-view-helper-sub';
import { PlessViewUtilsSub } from '../../../commons/kymw00/pless-view-utils-sub.service';
import { PlessDialogServiceSub } from '../../../commons/kymw00/pless-dialog-service-sub';
import { GetCwsPlanGoodsCategoryListModel } from './vo/get-cws-plan-goods-category-list.model';
import { GetCwsPlanGoodsCategoryListService } from './api-services/get-cws-plan-goods-category-list.service';
import { FileDownloadConfirmService } from '../../../commons/kymw02/file-download-confirm/file-download-confirm.service';
import { ClassCodeComboBoxComponent } from '../../../commons/kymw02/combo-box/class-code-combo-box/class-code-combo-box.component';
import { CwsPlanCategoryCodeComboBoxComponent } from '../../../commons/kymw02/combo-box/cws-plan-category-code-combo-box/cws-plan-category-code-combo-box.component';
import { OrderCodeTextInputComponent } from '../../../commons/kymw02/text-input/order-code-text-input/order-code-text-input.component';
import { CodeComboBoxComponent } from '../../../commons/kymw02/combo-box/code-combo-box/code-combo-box.component';
import { VMediumTypeComboBoxComponent } from '../../../commons/kymw02/combo-box/vmedium-type-combo-box/vmedium-type-combo-box.component';

/**
 * EC企画商品別カテゴリ設定一覧表画面を管理するクラス
 *
 * @export KYMW5800Component
 * @class KYMW5800Component
 */
@Component({
  selector: 'app-kymw5800',
  templateUrl: 'kymw5800.component.html',
  styleUrls: ['kymw5800.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class KYMW5800Component extends PlessViewHelperSub implements OnInit {

  // 親画面からの連携値
  param: any;

  kymw5800Model: KYMW5800Model = new KYMW5800Model();

  // 生協コードマスタ
  public coopData: Array<any> = null;

  @ViewChild('txti_OrderCode', { static: true }) txti_OrderCode: OrderCodeTextInputComponent;
  @ViewChild('chk_AllCoop', { static: true }) chk_AllCoop: ElementRef;
  @ViewChild('chk_Ibaraki', { static: true }) chk_Ibaraki: ElementRef;
  @ViewChild('chk_Tochigi', { static: true }) chk_Tochigi: ElementRef;
  @ViewChild('chk_Gunma', { static: true }) chk_Gunma: ElementRef;
  @ViewChild('chk_Chiba', { static: true }) chk_Chiba: ElementRef;
  @ViewChild('chk_Saitama', { static: true }) chk_Saitama: ElementRef;
  @ViewChild('chk_Tokyo', { static: true }) chk_Tokyo: ElementRef;
  @ViewChild('chk_Nagano', { static: true }) chk_Nagano: ElementRef;
  @ViewChild('chk_Niigata', { static: true }) chk_Niigata: ElementRef;
  @ViewChild('cmb_SiteDiv', { static: true }) cmb_SiteDiv: CodeComboBoxComponent;
  @ViewChild('cmb_MediumType', { static: true }) cmb_MediumType: VMediumTypeComboBoxComponent;
  @ViewChild('cmb_ClassCode', { static: true }) cmb_ClassCode: ClassCodeComboBoxComponent;
  @ViewChild('cmb_CategoryCode', { static: true }) cmb_CategoryCode: CwsPlanCategoryCodeComboBoxComponent;

  /**
   *Creates an instance of KYMW5800Component.
   * @param {PlessDialogServiceSub} dialogServiceSub
   * @param {KYMW00Model} kymw00Model
   * @memberof KYMW5800Component
   */
  constructor(
    private dialogServiceSub: PlessDialogServiceSub,
    public fileDownloadConfirmService: FileDownloadConfirmService,
    public getCwsPlanGoodsCategoryListService: GetCwsPlanGoodsCategoryListService,
    private kymw00Model: KYMW00Model,
    private elementRef: ElementRef,
  ) {
    super(kymw00Model);
  }

  /**
   * 初期処理
   *
   * @memberof PhaseRegistComponent
   */
  public ngOnInit(): void {
    this.componentName = 'KYMW5800';

    // 生協コード値のマップ
    this.coopData = [];
    this.coopData['chk_Ibaraki'] = this.kymw00Model.COOP_CODE_IB;
    this.coopData['chk_Tochigi'] = this.kymw00Model.COOP_CODE_TO;
    this.coopData['chk_Gunma'] = this.kymw00Model.COOP_CODE_GU;
    this.coopData['chk_Chiba'] = this.kymw00Model.COOP_CODE_TI;
    this.coopData['chk_Saitama'] = this.kymw00Model.COOP_CODE_SA;
    this.coopData['chk_Tokyo'] = this.kymw00Model.COOP_CODE_TK;
    this.coopData['chk_Nagano'] = this.kymw00Model.COOP_CODE_NA;
    this.coopData['chk_Niigata'] = this.kymw00Model.COOP_CODE_NI;
  }

  /**
   * 全生協選択の処理
   *
   * @memberof KYMW5800Component
   */
  public eventAllCoop_CHANGEHandler(): void {
    this.kymw5800Model.ibaraki = this.kymw5800Model.allCoop;
    this.kymw5800Model.tochigi = this.kymw5800Model.allCoop;
    this.kymw5800Model.gunma = this.kymw5800Model.allCoop;
    this.kymw5800Model.chiba = this.kymw5800Model.allCoop;
    this.kymw5800Model.saitama = this.kymw5800Model.allCoop;
    this.kymw5800Model.tokyo = this.kymw5800Model.allCoop;
    this.kymw5800Model.nagano = this.kymw5800Model.allCoop;
    this.kymw5800Model.niigata = this.kymw5800Model.allCoop;
  }

  /**
   * 出力ボタンを押下した時に呼び出されるメソッド
   *
   * @returns {void}
   * @memberof KYMW5800Component
   */
  public eventCSVOut_CLICKHandler(): void {
    // 入力チェック
    if (!this.inputCheck()) {
      return;
    }

    const vo: GetCwsPlanGoodsCategoryListModel = new GetCwsPlanGoodsCategoryListModel;
    vo.orderCode = this.txti_OrderCode.text;
    vo.classCode = PlessViewUtilsSub.nullToBlank(this.kymw5800Model.classCode);
    vo.categoryCode = PlessViewUtilsSub.nullToBlank(this.kymw5800Model.categoryCode);
    vo.siteDiv = PlessViewUtilsSub.nullToBlank(this.cmb_SiteDiv.reserve1);
    vo.mediumType = PlessViewUtilsSub.nullToBlank(this.cmb_MediumType.selectedMediumType);

    vo.coopCodeList = [];
    if (this.kymw5800Model.ibaraki) {
      vo.coopCodeList.push(this.coopData['chk_Ibaraki']);
    }
    if (this.kymw5800Model.tochigi) {
      vo.coopCodeList.push(this.coopData['chk_Tochigi']);
    }
    if (this.kymw5800Model.gunma) {
      vo.coopCodeList.push(this.coopData['chk_Gunma']);
    }
    if (this.kymw5800Model.chiba) {
      vo.coopCodeList.push(this.coopData['chk_Chiba']);
    }
    if (this.kymw5800Model.saitama) {
      vo.coopCodeList.push(this.coopData['chk_Saitama']);
    }
    if (this.kymw5800Model.tokyo) {
      vo.coopCodeList.push(this.coopData['chk_Tokyo']);
    }
    if (this.kymw5800Model.nagano) {
      vo.coopCodeList.push(this.coopData['chk_Nagano']);
    }
    if (this.kymw5800Model.niigata) {
      vo.coopCodeList.push(this.coopData['chk_Niigata']);
    }

    this.getCwsPlanGoodsCategoryListService.execute(this.kymw5800Model, vo, (data: any) => {
      // ファイル名の設定
      const fileName = 'EC企画商品別カテゴリ設定一覧表_' + PlessViewUtilsSub.formatedNowDate('YYYYMMDD_hhmmss') + '.tsv';

      this.fileDownloadConfirmService.show(data.FileName, fileName);
    });
  }

  /**
   * 入力チェック
   *
   * @private
   * @returns {boolean} true:OK false:NG
   * @memberof KYMW5800Component
   */
  private inputCheck(): boolean {
    // 受注コード必須チェック
    if (PlessViewUtilsSub.isEmpty(this.kymw5800Model.orderCode)) {
      this.dialogServiceSub.openAlertGetMessage('E0110', ['受注コード']);
      return false;
    }
    // 受注コード存在チェック
    if (!this.txti_OrderCode.isValidOrderCode()) {
      this.dialogServiceSub.openAlertGetMessage('E0122', ['受注コード']);
      return false;
    }

    // 会員生協
    if (!this.kymw5800Model.ibaraki &&
      !this.kymw5800Model.tochigi &&
      !this.kymw5800Model.gunma &&
      !this.kymw5800Model.chiba &&
      !this.kymw5800Model.saitama &&
      !this.kymw5800Model.tokyo &&
      !this.kymw5800Model.nagano &&
      !this.kymw5800Model.niigata) {
      this.dialogServiceSub.openAlertGetMessage('E0103', ['会員生協']);
      return false;
    }

    return true;
  }

  /**
   * 受注コード入力イベント
   *
   * @memberof KYMW5800Component
   */
  public eventOrderCode_CHANGEHandler(): void {
    if (!PlessViewUtilsSub.isEmpty(this.txti_OrderCode.selectedCatalogID)) {
      this.cmb_CategoryCode.selectedOrderCode = this.kymw5800Model.orderCode;
      // サイト区分の選択を保持
      // 未選択の場合、在庫限定フラグは初期値の0に設定
      this.cmb_SiteDiv.updateBindedField(null);
      if (this.cmb_SiteDiv.reserve1 !== "") this.cmb_CategoryCode.stockLimitFlg = this.cmb_SiteDiv.reserve1;
      this.cmb_CategoryCode.updateCategoryList();
    } else {
      this.cmb_CategoryCode.clear();
    }
  }
}
